export default __webpack_public_path__ + "static/media/integrate.e6c66239.svg";